module.exports = __webpack_public_path__ + "img/buddy_ears-04.fbd44c44.svg";